import { defineComponent as _defineComponent } from 'vue'
import { IFavoriteLine } from "@/domain/entities/favoriteLine";
import { computed, PropType } from "vue";
import FavoriteLineSetTypeChip from "../shared/chip/FavoriteLineSetTypeChip.vue";

import FavoriteStatusButton from "./FavoriteStatusButton.vue";
import BoardingStatusButton from "./BoardingStatusButton.vue";
import { LineTypeCode } from "@/types";
import useGetLineRouteName from "@/use/useGetLineRouteName";
import { convertToRangeGateNames } from "@/utils/convertToRangeGateNames";


const __default__ = {
  name: "FavoriteLineRow",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  favoriteLine: {
    type: Object as PropType<IFavoriteLine>,
    required: true,
  },
},
  emits: ["onClickFavoriteStatusButton", "onClickBoardingStatusButton", "onClickRow"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const emitOnClickFavoriteStatusButton = () => {
  emit("onClickFavoriteStatusButton");
};

const emitOnClickBoardingStatusButton = () => {
  emit("onClickBoardingStatusButton");
};

const emitOnClickRow = () => {
  emit("onClickRow");
};

const departureTimeText = computed(() => {
  const { lineTypeCode, busStops } = props.favoriteLine;
  return lineTypeCode === LineTypeCode.Inside
    ? ""
    : ` ${busStops[0]?.departureTime ?? ""}`;
});

const isBoarding = computed(() => props.favoriteLine.isBoarding);

const gateNoText = computed(() => {
  const { gateNoList } = props.favoriteLine;
  if (!gateNoList?.length) return "";

  // 다른 정류장의 승강장 위치인 경우 '/'' 로 구분, 하나의 정류장의 여러개의 승강장 위치인 경우는 ',' 로 구분됨
  const gateNoListByBusSt = gateNoList?.split("/");
  const gateNoText = gateNoListByBusSt
    .map((gateNo) => convertToRangeGateNames(sortGateNoList(gateNo)))
    .join(" / ");
  return `(${gateNoText})`;
});

const sortGateNoList = (gateNoList: string): string[] => {
  return gateNoList
    .split(",")
    .map((v) => v.trim())
    .sort((a, b) => {
      const [aPrefix, aNum] = splitAlphaNum(a);
      const [bPrefix, bNum] = splitAlphaNum(b);

      const prefixCompare = aPrefix.localeCompare(bPrefix);
      if (prefixCompare !== 0) return prefixCompare;

      return aNum - bNum;
    });
};

const splitAlphaNum = (value: string): [string, number] => {
  const match = value.match(/^([^\d]+)?(\d.+)?$/); // 알파벳 + 숫자 또는 숫자-숫자 조합
  const prefix = match?.[1] || "";
  const numPart = match?.[2] || "";

  // "2-5" 같은 형식도 고려해서 숫자 부분을 적절히 변환
  const num = parseFloat(numPart.replace("-", ".")); // "2-5" => 2.5

  return [prefix, isNaN(num) ? 0 : num];
};

const __returned__ = { props, emit, emitOnClickFavoriteStatusButton, emitOnClickBoardingStatusButton, emitOnClickRow, departureTimeText, isBoarding, gateNoText, sortGateNoList, splitAlphaNum, FavoriteLineSetTypeChip, FavoriteStatusButton, BoardingStatusButton, get useGetLineRouteName() { return useGetLineRouteName } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})